export class DateUtil {
  private _date: Date;

  constructor(date: Date) {
    this._date = date;
  }

  static now(): Date {
    return new Date();
  }

}
